import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemEventsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-events',
	path: '/secure/admin/ListEventTypes.jspa',
};
